"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvJSON = exports.getEnvBool = exports.getEnvString = exports.getEnvNumber = void 0;
const evaluate = (key) => {
    return (process.env.hasOwnProperty(key) &&
        process.env[key] &&
        process.env[key] !== 'undefined');
};
const getEnvNumber = (key, fallback = undefined) => {
    if (evaluate(key)) {
        return parseInt(process.env[key], 10);
    }
    return fallback;
};
exports.getEnvNumber = getEnvNumber;
const getEnvString = (key, fallback = undefined) => {
    if (evaluate(key)) {
        return process.env[key];
    }
    return fallback;
};
exports.getEnvString = getEnvString;
const getEnvBool = (key, fallback = undefined) => {
    if (evaluate(key)) {
        return process.env[key] == 'true' ? true : false;
    }
    return fallback;
};
exports.getEnvBool = getEnvBool;
const getEnvJSON = (key, fallback = {}) => {
    if (evaluate(key)) {
        return JSON.parse(process.env[key]);
    }
    return fallback;
};
exports.getEnvJSON = getEnvJSON;
